import React from 'react'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Input from 'Components/Input'
import Utils from 'EurestoFonction/Utils'
import Title from "Components/Title";
import DatePicker from "Components/DatePicker";
import moment from "moment";


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getActivite()
    }
  }

  getActivite = async () => {
    const result = await ApiRequest(project.api + 'pedagogie', {
      requete: 'eleve',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if(result && result.code === 1) {
      const newState = {
        nom: result.results.nom || '',
        prenom: result.results.prenom || '',
        email: result.results.email || '',
        fixe: result.results.fixe || '',
        portable: result.results.portable || '',
        civilite_id: result.results.civilite_id || undefined,
        classes: result.results.classes ||[],
        qualite_id: result.results.qualite_id || undefined,
        media_id: result.results.media_id || '',
        media_lien: result.results.media_lien,
        login: result.results.email_identification && result.results.email_identification.split('@')[0] || '',
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      nom: '',
      prenom: '',
      email: '',
      fixe: '',
      portable: '',
      password: '',
      civilite_id: undefined,
      qualite_id: undefined,
      media_id: undefined,
      classses: [],
      key: Utils.getRandomNumber(),
      action: 'add',
      login: '',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'pedagogie', {
      requete: 'eleve',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      nom: this.state.nom || '',
      prenom: this.state.prenom || '',
      email: this.state.email || '',
      fixe: this.state.fixe || '',
      portable: this.state.portable || '',
      civilite_id: this.state.civilite_id || undefined,
      qualite_id: this.state.qualite_id || undefined,
      media_id: this.state.media_id || '',
      login: this.state.login || '',
      classes: this.state.classes || [],
      password: this.state.login || '',
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'pedagogie', {
      requete: 'eleve',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = {...EurestoClone(this.state.saveState)}
    newState.key = Utils.getRandomNumber();
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  onChangeClasse = (index) => (data, name) => {
    if(name === 'annee') {
      data = moment(data[0]).format('YYYY')
    }

    const {classes} = this.state
    classes[index][name] = data

    this.setState({
      classes: classes
    }, this.forceUpdate)
  }

  onAddClasse = _ => {
    const classes = this.state.classes || []
    classes.push({
      annee: moment().isBefore(moment().format('YYYY-07-05')) ? moment().subtract(1, 'years').format('YYYY') : moment().format('YYYY')
    })
    this.setState({
      classes: classes
    }, this.forceUpdate)
  }

  onDeleteClasse = (i) => {
    const {classes} = this.state
    classes.splice(i, 1)
    this.setState({
      classes: classes
    }, this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid container spacing={0} style={{margin: 0, padding: 0}} justify={'flex-start'} alignItems={"stretch"} alignContent={"center"}>
          <DataComponent
            onChange={this.onChangeState}
            name="picture"
            type={Constants.typeSaisie.Picture}
            avatarStyle={{maxWidth: '90%'}}
            defineData={true}

            data={{
              id: this.state.media_id,
              lien: this.state.media_lien
            }}
            object={{
              picture: {
                id: this.state.media_id,
                lien: this.state.media_lien
              },
              id: this.state.id,
            }}/>
            <Input
                onChange={this.onChangeState}
                name="login"
                type="text"
                value={this.state.login}
                title={EurestoI18n.t('crm:Login')}
            />
            <DataComponent
              name="civilite_id"
              autoFocus={autoFocus}
              type={Constants.typeSaisie.ComboSimple}
              onChange={this.onChangeState}

              data={this.state.civilite_id}
              object={Constants.donnee.civilite}
              module={Constants.module.COMMUN}
              search={{type: 1}}
            />
            <Input
              onChange={this.onChangeState}
              name="nom"
              type="text"
              className="upText"
              value={this.state.nom}
              title={EurestoI18n.t('crm:Nom')}
            />
            <Input
              onChange={this.onChangeState}
              name="prenom"
              type="text"
              value={this.state.prenom}
              title={EurestoI18n.t('crm:Prénom')}
            />
            <Input
              onChange={this.onChangeState}
              name="email"
              type="text"
              value={this.state.email}
              title={EurestoI18n.t('crm:Email')}
            />
            {this.state.action !== 'update' && this.state.action !== 'view' &&
            <Input
                onChange={this.onChangeState}
                name="password"
                type="text"
                value={this.state.password}
                title={EurestoI18n.t('crm:Mot de passe')}
            />}
            <Input
              onChange={this.onChangeState}
              name="fixe"
              type="text"
              value={this.state.fixe}
              title={EurestoI18n.t('crm:Téléphone Fixe')}
            />
            <Input
              onChange={this.onChangeState}
              name="portable"
              type="text"
              value={this.state.portable}
              title={EurestoI18n.t('crm:Téléphone Portable')}
            />

            <Title
                style={{padding: '5px 0'}} title={'Classe'}
                buttons={!disabled &&
                <button type="button" onClick={this.onAddClasse}
                        disabled={disabled}
                        className="text-success ei-commun_ajouter"
                        style={{display: 'inline-block', margin: '0px 5px'}}/>}>

              {
                (this.state.classes || []).map((data, index) => (
                    <Grid key={index+data.annee} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                          alignItems={'center'}>
                      <Grid item xs={4} style={{margin: 0, padding: 0}}>
                        <DatePicker
                            year
                            scolaire
                            title={EurestoI18n.t('commun:Année Scolaire')}
                            onChange={this.onChangeClasse(index)}
                            name={'annee'}
                            disabled={disabled}
                            value={[moment(data.annee+'-01-01').format('YYYY-MM-DD'), moment(data.annee+'-12-31').format('YYYY-MM-DD')]}
                        />
                      </Grid>
                      <Grid item xs={7} style={{margin: 0, padding: 0}}>
                        <DataComponent
                            subDataOption
                            dataMere={'classe_id'}
                            title={EurestoI18n.t('commun:Classe')}
                            name="classe_id"
                            disabled={disabled}
                            search={{annee: parseInt(data.annee)}}
                            type={Constants.typeSaisie.ComboSimple}
                            onChange={this.onChangeClasse(index)}
                            data={data.classe_id}
                            object={Constants.donnee.classe}
                            module={Constants.module.PEDAGOGIE}/>
                      </Grid>
                      <Grid item xs={1}>
                        <button type="button" onClick={() => this.onDeleteClasse(index)}
                                className="text-danger ei-commun_enlever"
                                disabled={disabled}/>
                      </Grid>
                    </Grid>
                ))
              }
            </Title>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.nom}
                   action={this.state.action}
                   isAllow={{...this.props.isAllow, update: true}}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvel Élève')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Pedagogie/Eleve.js